import React from 'react';
import PropTypes from 'prop-types';
import styles from './FieldRadio.m.sass';

import cx from 'classnames';

export default function FieldRadio({input, meta: {touched, error} = {}, title, children, label, className, ...rest}) {
  const displayError = (touched && error);

  return (
    <div className={cx(styles.fieldRadio, className)}>
      {title && <div className={styles.fieldRadio_title}>{title}</div>}

      <div className={styles.fieldRadio_wrap}>
        <label className={styles.fieldRadio_name}>
          <input {...rest} {...input} type="radio" className={styles.fieldRadio_input}/>
          <span className={styles.fieldRadio_text}>{children}</span>
        </label>

        {displayError && (<div className={styles.fieldRadio_errorMessage}>{error}</div>)}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldRadio/FieldRadio.js